import axios from '../config/AxiosConfig'
import platformConfig from '@/config/PlatformConfig'
import store from '@/store'

const api = {
  async get (url, data, apiUniqueUrlType) {
    this.baseURLModify(apiUniqueUrlType)
    try {
      const res = data ? await axios.get(`${url}?data=${data}`) : await axios.get(url)
      // console.log('res', res)
      return new Promise((resolve, reject) => {
        // resolve(res)
        if (res.data.code === 'G_00001') {
          resolve(res)
        } else {
          reject(res)
          this.errorCodeHandler(res.data.code)
        }
      })
    } catch (err) {
      console.error('GET', err)
    }
  },
  async post (url, data, apiUniqueUrlType) {
    this.baseURLModify(apiUniqueUrlType)
    const postData = typeof data === 'string' ? { data: data } : data
    try {
      const res = data ? await axios.post(url, postData) : await axios.post(url)
      return new Promise((resolve, reject) => {
        if (res.data.code === 'G_00001' || apiUniqueUrlType) {
          resolve(res)
        } else {
          reject(res)
          this.errorCodeHandler(res.data.code)
        }
      })
    } catch (err) {
      console.error('POST', err)
    }
  },
  baseURLModify (apiUniqueUrlType) {
    axios.defaults.baseURL = apiUniqueUrlType ? platformConfig.apiUniqueUrl[apiUniqueUrlType] : platformConfig.baseURL ? platformConfig.baseURL : `${window.location.protocol}//${window.location.host}/gateway`
  },
  errorCodeHandler (errorCode) {
    const handlerList = {
      G_00107: () => { setTimeout(this.logout, 2000) },
      G_00108: () => { setTimeout(this.logout, 2000) }
    }
    const handler = handlerList[errorCode] ? handlerList[errorCode] : () => {}
    handler()
  },
  async logout () {
    try {
      await store.dispatch('Logout')
      location.reload()
    } catch (err) {
      console.error(err)
      location.reload()
    }
  }
}
export { api }
